import moment from "moment";
import { Localize } from "../../app/lang/langs";
import ExcelManager from "../../app/managers/excelManager";

export function exportExcelContracts(filteredContracts, allContractsList) {
  let filteredData = filteredContracts || allContractsList;
  let exportDataContract = filteredData.reduce((array, current) => {
    let contractData = {
      "Prénom": current.prenom || "",
      "Nom de famille": current.nom || "",
      "ID": current.id || "",
      "ID Collaborateur": current.id_collab || "",
      "ID Entreprise": current.id_company || "",
      "ID Sous-traitant": current.id_subcontractor || "",
      "Type de contrat": current.type_contrat || "",
      "Type de collaborateur": current.type_collab || "",
      "Statut emploi": current.statut_emploi || "",
      "Date d'entrée": current.entree_date ? moment(current.entree_date).format("DD-MM-YYYY") : "",
      "Date de sortie": current.sortie_date ? moment(current.sortie_date).format("DD-MM-YYYY") : "",
      "Poste": current.position || "",
      "Coefficient": current.coefficient || "",
      "Code CSP": current.code_csp || "",
      "Période d'essai 1": current.periode_essai_1 ? moment(current.periode_essai_1).format("DD-MM-YYYY") : "",
      "Période d'essai 2": current.periode_essai_2 ? moment(current.periode_essai_2).format("DD-MM-YYYY") : "",
      "Mise sous pli": current.mise_sous_pli || "",
      "Dédit formation": current.dedit_formation || "",
      "Motif de sortie": current.motif_sortie || "",
      "Durée période d'essai 1": current.duree_periode_essai_1 || "",
      "Durée période d'essai 2": current.duree_periode_essai_2 || "",
      "Date rappel 1": current.date_rappel_1 ? moment(current.date_rappel_1).format("DD-MM-YYYY") : "",
      "Date rappel 2": current.date_rappel_2 ? moment(current.date_rappel_2).format("DD-MM-YYYY") : "",
      "N'a pas démarré": current.did_not_start || "",
      "TJM achat": current.tjm_achat || "",
      "TJM vente": current.tjm_vente || "",
      "Date début CP": current.date_debut_cp ? moment(current.date_debut_cp).format("DD-MM-YYYY") : "",
      "Date fin CP": current.date_fin_cp ? moment(current.date_fin_cp).format("DD-MM-YYYY") : "",
      "Nouvelle date début CP": current.new_date_debut_cp ? moment(current.new_date_debut_cp).format("DD-MM-YYYY") : "",
      "Nouvelle date fin CP": current.new_date_fin_cp ? moment(current.new_date_fin_cp).format("DD-MM-YYYY") : "",
      "Date d'envoi": current.sent_date ? moment(current.sent_date).format("DD-MM-YYYY") : "",
      "Mutuelle": current.mutuelle || "",
      "Ticket restaurant": current.ticket_restaurant || "",
      "Pass Navigo": current.pass_navigo || "",
      "Taux horaire": current.taux_horaire || "",
      "Établissement": current.etablissement || "",
      "Nature emploi": current.nature_emploi || "",
      "Renouvellement période d'essai": current.renew_periode_essai || "",
      "Responsable contractuel": current.responsable_contractuel || "",
      "Statut Silae": current.silae_status || "",
      "Date de création": current.created_at ? moment(current.created_at).format("DD-MM-YYYY") : "",
      "Date de mise à jour": current.updated_at ? moment(current.updated_at).format("DD-MM-YYYY") : "",
      "Créé par": current.created_by || "",
      "Mis à jour par": current.updated_by || "",
      "Nom sous-traitant": current.subcontractor_name || "",
      "Tuteur": current.tutor_name || "",
      "Ecole": current.school || "",
      "Contact école": current.school_contact || "",
      "Diplome": current.diploma || "",
      "Coût de la formation": current.training_cost || "",
      "Reste à charge": current.remaining_cost || "",
      "Commentaires": current.comments || "",
    };
    array.push(contractData);
    return array;
  }, []);
  ExcelManager.getInstance().generateAndDownloadExcelFromData(exportDataContract, "contrats_collaborateurs");
}

export function exportExcelMissions(filteredMissions, allMissionsList) {
  let filteredData = filteredMissions || allMissionsList;
  let exportDataMissions = filteredData.reduce((array, current) => {
    let missionData = {
      "Prénom": current.prenom || "",
      "Nom de famille": current.nom || "",
      "Equipe": current.current_team_name || "",
      "Localization": current.current_team_location || "",
      "Poste": current.poste_name || "",
      "Groupe": current.group_name || "",
      "Date début": current.start_date ? moment(current.start_date).format("DD-MM-YYYY") : "",
      "Date fin": current.end_date ? moment(current.end_date).format("DD-MM-YYYY") : "",
      "Créé": current.created_at ? moment(current.created_at).format("DD-MM-YYYY") : "",
      "Créé par": current.created_by || "",
      "MAJ": current.updated_at ? moment(current.updated_at).format("DD-MM-YYYY") : "",
      "MAJ par": current.updated_by || "",
    };
    array.push(missionData);
    return array;
  }, []);
  ExcelManager.getInstance().generateAndDownloadExcelFromData(exportDataMissions, "missions_collaborateurs");
}

export function exportExcelSuivisMissions(filteredMissionsSuivis, allMissionsFollowups) {
  let filteredData = filteredMissionsSuivis || allMissionsFollowups;
  let exportDataSuivisMissions = filteredData.reduce((array, current) => {
    let suivisMissionData = {
      "Prénom": current.prenom || "",
      "Nom de famille": current.nom || "",
      "Semaine": current.week || "",
      "Statut": Localize(current.status) || "",
      "Suivi": Localize(current.type) || "",
      "Client": current.client || "",
      "Equipe": current.current_team_name || "",
      "Commentaires": current.comments || "",
      "Managers": current.managers || "",
      "Créé": current.created_at ? moment(current.created_at).format("DD-MM-YYYY") : "",
      "Créé par": current.createdBy || "",
      "MAJ": current.updated_at ? moment(current.updated_at).format("DD-MM-YYYY") : "",
      "MAJ par": current.updatedBy || "",
    };
    array.push(suivisMissionData);
    return array;
  }, []);
  ExcelManager.getInstance().generateAndDownloadExcelFromData(exportDataSuivisMissions, "suivis_missions_collaborateurs");
}
